// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"f213e59a","583":"f213e59a","651":"7a5a989d"}[chunkId] + ".chunk.css";
};